import React,{useEffect, useState} from "react";
import DocumentNavbar from "./DocumentNavbar";
import './Table.css';
import ReactPaginate from "react-paginate";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function NewCompaniesManager() {
  const ID = Cookies.get("log_id");
  const [companies,setCompanies] = useState([]);
  const [employees,setEmployees] = useState([]);
  const [employee,setEmployee] = useState("");
      function NewCompanies() {
        axios.get(`${url.path}/new_companies/`)
        .then((res) =>{
          if (res.data.status){
              var cmps = res.data.company;
              var emps = res.data.employees;
              setCompanies([])
              cmps.map((i)=>{
                setCompanies((prevState) =>[
                  ...prevState, i
                ])
              })
              setEmployees([])
              emps.map((e)=>{
                setEmployees((prevState)=>[
                  ...prevState, e
                ])
              })
          }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
        })
      }
      useEffect(() =>{
        NewCompanies();
      },[])
      const itemsPerPage = 3;
      const [searchTerm, setSearchTerm] = useState("");
      const [currentPage, setCurrentPage] = useState(0);

      const filteredData = companies.filter((item) =>
        item.Company_name.toLowerCase().includes(searchTerm.toLowerCase())
      );

      const offset = currentPage * itemsPerPage;
      const currentItems = filteredData.slice(offset, offset + itemsPerPage);
      const pageCount = Math.ceil(filteredData.length / itemsPerPage);

      const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
      };
      function searchTable(){
        var rows = document.querySelectorAll('#companytable tbody tr');
        var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
        rows.forEach(function(row) {
          var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
          row.style.display = text.includes(val) ? '' : 'none';
        });
      }
      const [selectedCompany, setSelectedCompany] = useState(null);
      const handleOpenModal = (cmp) => {
        setSelectedCompany(cmp);
      };
      const handleCloseModal = () => {
        setSelectedCompany(null);
      };
      const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
      function Assign(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('ID',ID);
        formdata.append('employee',employee);
        formdata.append('company',selectedCompany.id);
        axios.post(`${url.path}/assign_document/`,formdata)
        .then((res) =>{
          if (res.data.status){
            Toast.fire({
              icon:'success',
              title:'Document Assigned...'
            });
            handleCloseModal();
            NewCompanies();
          }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
        })
      }
    return(
        <>
        <DocumentNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>New Companies</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
            <div className="search-container">
  </div>
        <div className="table-container">
      <table className="responsive-table" id="companytable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Company_name}</td>
              <td>{i.Email}</td>
              <td>{i.Contact_number}</td>
                <td><button type="button" id="assignbutton" onClick={() => handleOpenModal(i)}>Assign</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {selectedCompany && (
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={handleCloseModal}
        >
          &times;
        </button>
        <h2>Assign Employee</h2>
        <p>Assign an employee to {selectedCompany.Company_name}</p>
        <form onSubmit={Assign}>
          <div className="form-group-row">
            <div className="form-group">
            <label style={{fontSize:'15px'}}>Employee Name:</label>
            <select id="empname" value={employee} onChange={(e) =>setEmployee(e.target.value)}>
              <option>--Select--</option>
              {employees && employees.map((i)=>(
                <option value={i.id}>{i.Employee_Name}</option>
              ))}
            </select>
            </div>
          </div>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}}>Assign</button>
          </center>
        </form>
      </div>
    </div>
  )}
     
    
        </>
    );
}
export default NewCompaniesManager;